import React, { useState } from 'react';
import PlayerCard from './PlayerCard';
import TeamTabs from './TeamTabs';

const TeamSection = ({ roster, staff, backgroundImage, pergaminoImage }) => {
  const [activeTab, setActiveTab] = useState('roster');

  return (
    <div className="relative mt-[-128px]"> {/* Ajustamos el margen negativo para subir todo el contenido */}
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={backgroundImage}
          alt=""
          className="w-full object-contain object-top"
          style={{
            maskImage: "linear-gradient(to bottom, rgba(0, 0, 0, 1) 80%, rgba(0, 0, 0, 0) 100%)",
            WebkitMaskImage: "linear-gradient(to bottom, rgba(0, 0, 0, 1) 80%, rgba(0, 0, 0, 0) 100%)"
          }}
        />
      </div>

      {/* Content */}
      <div className="relative container mx-auto px-4 pt-44"> {/* Aumentamos el padding top para compensar */}
        <div className="flex justify-left mb-12">
          <img
            src={pergaminoImage}
            alt=""
            className="h-32 object-contain"
          />
        </div>

        <TeamTabs activeTab={activeTab} onTabChange={setActiveTab} />

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
          {(activeTab === 'roster' ? roster : staff).map((player) => (
            <PlayerCard
              key={player.nickname}
              {...player}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeamSection;